import { createdBoxQueries } from '@/entities/sets/created';
import { usePersistStore } from '@/shared/lib/store';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { KvResultContainer, Modal } from '@/shared/ui';
import { normalizeDifficulty } from '@/shared/utils/common';
import { getCountArticleList, getDifficultyArticleList } from '@/shared/utils/created';
import { difficultyMap } from '@/shared/utils/publish';
import { CreatedDataHeader } from '@/widgets/section-header';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

export const Route = createFileRoute('/sets/created-box/detail/$examId')({
    component: RouteComponent,
    loader: ({ params }) => {
        return { examId: Number(params.examId) };
    },
});

function RouteComponent() {
    const router = useRouter();
    const { examId } = Route.useLoaderData();
    const { sToken, sUserId } = usePersistStore();
    const { showModal, closeModal } = useModalStore();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data, isFetched } = createdBoxQueries.getCreatedBoxDetail(
        {
            examId,
            wrterId: sUserId,
        },
        !!sToken
    );

    const articleList: DATA.ArticleInfo[] = getDifficultyArticleList(data?.articleList!);
    const countList: DATA.ArticleInfo[] = getCountArticleList(data?.articleList!);
    // const articleList: DATA.ArticleInfo[] = data?.articleList ??;

    const difficultyCount = countList?.reduce<Record<string, number>>((acc, cur) => {
        const d = normalizeDifficulty(cur.mdulDifyNm!);
        acc[d] = (acc[d] || 0) + 1;
        return acc;
    }, {});

    const order = ['상', '중', '하'];

    const difficultyArray =
        difficultyCount &&
        Object.entries(difficultyCount)
            // [키, 값] 배열을 order 순서대로 정렬
            .sort(([a], [b]) => order.indexOf(a) - order.indexOf(b))
            .map(([key, value]) => ({
                diffy: key,
                diffyCnt: value,
            }));

    const priority: { [key: string]: number } = {
        상: 1,
        중: 2,
        하: 3,
    };

    const difficultySortArray = difficultyArray.sort(
        (a, b) => priority[a.diffy] - priority[b.diffy]
    );

    useEffect(() => {
        if (
            (!!data?.resultMsg &&
                (data.resultMsg === '접근 권한이 없습니다' ||
                    data.resultMsg === '출제 작성자와 조회 계정이 다릅니다')) ||
            (isFetched && data === undefined)
        ) {
            setIsModalOpen(true);
        } else {
            setIsModalOpen(false);
        }
    }, [data, isFetched]);

    // if (isLoading || !data) {
    //     return null;
    // }

    return (
        <>
            <Modal
                open={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    router.history.back();
                }}
                title="안내"
                description={
                    <>
                        접근 권한이 없습니다.
                        <br />
                        본인이 출제한 평가지에만 접근할 수 있습니다.
                    </>
                }
            />
            <section className="contwrap submittedBox_detail">
                <div className="contInner" id="submittedDetail">
                    <div className="report-content layout-type3">
                        <div className="add-contents normal" style={{ position: 'relative' }}>
                            <CreatedDataHeader data={data} />
                            <div className="content detail-content">
                                {/* TODO: 갯수 map 돌리기  */}
                                <div className="info-content bdrRad levelInfo">
                                    <span className="text-black total">총 </span>
                                    <span className="text-black count">
                                        {countList?.length ?? 0}개
                                    </span>
                                    {difficultySortArray?.map((item, idx) => {
                                        if (item.diffy === 'null') return;
                                        return (
                                            <span
                                                key={`difficulty-${idx}`}
                                                className={`circle-point round ${difficultyMap[item.diffy]}`}
                                            >
                                                {item.diffy === '산' ? '상' : item.diffy}{' '}
                                                {item.diffyCnt}개
                                            </span>
                                        );
                                    })}
                                    <span className="text-black endpoint">총점 : </span>
                                    <span className="text-red score">{data?.setTotalScr}점</span>
                                </div>
                                <div className="data-set-wrap">
                                    {/* 뷰어 단 */}
                                    {articleList?.map((item, idx) => (
                                        <div className="data-set" key={`create-article-${idx}`}>
                                            <ul>
                                                <li>
                                                    <div className="header">
                                                        <div className="info">
                                                            <span>
                                                                {item.questionType
                                                                    ? item.questionType?.join(', ')
                                                                    : item.articleType}
                                                            </span>
                                                            {item.articleType !== '개념' && (
                                                                <span>
                                                                    난이도{' '}
                                                                    {item.difficultyList[0]
                                                                        ?.mdulDifyCount > 1 ||
                                                                    item.difficultyList.length > 1 ? (
                                                                        item.difficultyList?.map(
                                                                            (d, idx) => (
                                                                                <span
                                                                                    key={`difficulty-${idx}`}
                                                                                    className={`circle-point round ${difficultyMap[d.mdulDifyNm]}`}
                                                                                >
                                                                                    {d.mdulDifyNm ===
                                                                                        '중하' ||
                                                                                    d.mdulDifyNm ===
                                                                                        '중상'
                                                                                        ? '중'
                                                                                        : d.mdulDifyNm}{' '}
                                                                                    {d.mdulDifyCount}개
                                                                                </span>
                                                                            )
                                                                        )
                                                                    ) : (
                                                                        <span
                                                                            className={`circle-point round ${
                                                                                difficultyMap[
                                                                                    item.mdulDifyNm ===
                                                                                        '중하' ||
                                                                                    item.mdulDifyNm ===
                                                                                        '중상'
                                                                                        ? '중'
                                                                                        : item.mdulDifyNm!
                                                                                ]
                                                                            }`}
                                                                        >
                                                                            {item.mdulDifyNm ===
                                                                                '중하' ||
                                                                            item.mdulDifyNm === '중상'
                                                                                ? '중'
                                                                                : item.mdulDifyNm}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            )}

                                                            {item.articleType !== '개념' && (
                                                                <span>
                                                                    <label htmlFor="">
                                                                        배점{' '}
                                                                        <input
                                                                            type="text"
                                                                            className="text-score"
                                                                            id=""
                                                                            value={item.mdulScr ?? ''}
                                                                        />
                                                                    </label>
                                                                </span>
                                                            )}
                                                            {/* 25.07.23 ai 영어지문 라벨 추가*/}
                                                            {item.source &&
                                                                item.source === 'AI영어지문마스터' && (
                                                                    <span className="icon_mark ai2">
                                                                        <i></i>
                                                                    </span>
                                                                )}
                                                            {/* 배점{' '}
                                                                <span className="text-red">
                                                                    {item.mdulScr}
                                                                </span> */}
                                                                {/* <span className="use-count isNumber textCloud-wrap">
                                                                <button type="button">
                                                                    <span className="sr-only">
                                                                        콘텐츠 사용 누적 횟수
                                                                    </span>
                                                                </button>
                                                                <span>{item.mdulUseCnt}</span>
                                                                <span className="textCloud type3">
                                                                    0반의 공유된 학급 자료 중<br />
                                                                    해당 콘텐츠가 사용된
                                                                    <br />
                                                                    누적 횟수입니다.
                                                                </span>
                                                            </span> */}
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <KvResultContainer
                                                            key={item.id}
                                                            articleId={item.id ?? ''}
                                                            subId={0}
                                                            setId={data?.setsId}
                                                            overflowY="none"
                                                            mode="scroll"
                                                            // style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
